import { Component, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent, CeLevelMenuBaseComponent, CeListImports, CeNameDisplayComponent, CePopoverImports, CePopoverTriggerForDirective } from '@kempower-nx-workspace/shared/kp-design-system';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { SidePanelLayoutService } from '@kempower-nx-workspace/layout-templates';
import { LICENSE_BASIC, LicenseInfoService } from '@kempower-nx-workspace/chargeye-licensing';

@Component({
    selector: 'ce-core-side-nav-profile-options',
    imports: [CommonModule, RouterLink, CeListImports, CeNameDisplayComponent, CeIconComponent, CeLevelMenuBaseComponent, CePopoverImports],
    templateUrl: './side-nav-profile-options.component.html'
})
export class CoreSideNavProfileOptionsComponent implements OnInit {
    popoverProfileRef!: CePopoverTriggerForDirective;
    popoverOrgSwitchRef!: CePopoverTriggerForDirective;
    userName = input<string>('');

    readonly #router = inject(Router);
    readonly #destroyRef = inject(DestroyRef);
    readonly #sidePanelLayoutService = inject(SidePanelLayoutService);
    readonly #licenseInfoService = inject(LicenseInfoService);

    isProfileActive = signal(false);

    readonly hasProfileSettingsAccess = toSignal(
        this.#licenseInfoService.hasHighEnoughLicense$(LICENSE_BASIC),
        { initialValue: false },
    );

    ngOnInit(): void {
        this.isProfileActive.set(this.#router.url.includes('/profile-settings'));

        this.#router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                takeUntilDestroyed(this.#destroyRef),
            )
            .subscribe((event) => {
                this.isProfileActive.set(event.url.includes('/profile-settings'));
            });
    }
    profileRef($event: CePopoverTriggerForDirective): void {
        this.popoverProfileRef = $event;
        if (this.popoverOrgSwitchRef) {
            this.popoverOrgSwitchRef.hidePopup();
        }
    }

    closeProfile(): void {
        if (this.popoverProfileRef) {
            this.popoverProfileRef.hidePopup();
        }
        this.#sidePanelLayoutService.closeSidePanel();
    }
}
